<template>
  <div>
    <authentication-forms-container :image="image">
      <form @submit.prevent="onSubmit" class="mt-2">
        <h4 class="text-primary" v-t="'reset_email_password.title'"></h4>

        <div class="form-row">
          <div class="col">

            <div class="form-group mb-4 mt-3">
              <label for="password" v-t="'authentication_general.password'"></label>
              <input v-model="form.password" type="password"
                     :placeholder="$t('authentication_general.password_placeholder')"
                     class="form-control rounded-pill  mt-3" id="password">
              <form-errors-manager :validation="v$.form.password"/>
            </div>
          </div>

          <div class="col">

            <div class="form-group mb-4 mt-3">
              <label for="password_confirmation" v-t="'authentication_general.password_confirm'"></label>
              <input v-model="form.password_confirmation" type="password"
                     :placeholder="$t('authentication_general.password_confirm_placeholder')"
                     class="form-control rounded-pill  mt-3" id="password_confirmation">
              <form-errors-manager :validation="v$.form.password_confirmation"/>
            </div>


          </div>
        </div>

        <div class="my-4">
          <m-captcha1 v-model="form.captcha_answer"/>
          <form-errors-manager :validation="v$.form.captcha_answer"/>
        </div>


        <button type="submit" class="my-3 w-100 btn btn-block btn-primary rounded-pill"
                v-t="'reset_email_password.button_submit'"
        >
        </button>
      </form>
    </authentication-forms-container>
  </div>
</template>

<script>
import {useVuelidate} from '@vuelidate/core'
import {sameAs, required, minLength, maxLength} from "@vuelidate/validators";

import FormErrorsManager from "../../validator/FormErrorsManager";
import {mapGetters} from "vuex";
import AuthenticationFormsContainer from "../Form/AuthFormsContainer";
import router from "@/router";
import mCaptcha1 from "../../Captcha/Captcha1";
import {captchaValidation} from "../../Captcha/CaptchaValidation";

export default {
  name: "EmailForgetPassword",
  components: {FormErrorsManager, AuthenticationFormsContainer, mCaptcha1},
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      form: {
        password: "",
        password_confirmation: "",
        captcha_answer: ''
      },
    };
  },
  props: {
    image: {
      type: String,
      default: null
    }
  },
  validations() {
    return {
      form: {
        password: {required, minLength: minLength(4)},
        password_confirmation: {required, sameAsPassword: sameAs(this.formPassword)},
        captcha_answer: captchaValidation,
      },
    }
  },
  computed: {
    ...mapGetters({
      emaill: "Authentication/getEmailForForgetPassword",
    }),
    formPassword() {
      return this.form.password
    }
  },
  methods: {
    async onSubmit() {
      const result = await this.v$.form.$validate()
      if (!result) return
      const token = router.currentRoute.params.token.split("=")[1]
      const email = router.currentRoute.params.email.split("=")[1]
      const form = {token: token, email: email, ...this.form};
      console.log(form);
      this.$store.dispatch("Authentication/emailResetPassword", form);
    },
  },
};
</script>
<style scoped></style>
